<ng-container [formGroup]="form">
  <quill-editor [formControlName]="element.form" [ngClass]="{'is-invalid': isInvalid}"></quill-editor>
  <div class="invalid-feedback" *ngIf="isInvalid">
    <span *ngIf="isRequired">Please provide a valid {{ element.label }}</span>
  </div>
</ng-container>
